import * as React from "react";
import {Navigate} from "react-router-dom";

import AppLayout from "Layout";
import {DIGITAL_SHELF_ROUTES} from "@constants"
import DigitalShelfGeneralPage from "./General";


export const DigitalShelfRoutes = {
    path: DIGITAL_SHELF_ROUTES.PATH,
    title: DIGITAL_SHELF_ROUTES.TITLE,
    accessKey: DIGITAL_SHELF_ROUTES.ACCESS_KEY,
    icon: 'ballot-check',
    description: "Ensure Optimal Exposure of Your Products or Brand on Key E-commerce Sites",
    element: <AppLayout />,
    children: [{
        element: <Navigate to={DIGITAL_SHELF_ROUTES.OVERVIEW_PATH} replace />,  index: true
    }, {
        title: 'Overview',
        path: DIGITAL_SHELF_ROUTES.OVERVIEW_PATH,
        dashboardKey: DIGITAL_SHELF_ROUTES.OVERVIEW_ID,
        element: <DigitalShelfGeneralPage />
    }]
}